import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Input from '../../../../components/Form/Input';
import Select from '../../../../components/Form/Select';
import axios from 'axios';
// import { region, district } from "../../../../plateform/datas/RegionDistrict";
import {districtDatas as district, regionDatas as region} from '../../../../plateform/datas/RegionDistrict'
import { API_END_POINT } from '../../../../utils/constant'
import ButtonBlack from '../../../../components/Buttons/ButtonBlack';


const CreateTrainerAccount = ({ setPage, page, data, setData }) => { 
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
   const [touchedFields, setTouchedFields] = useState({});

  // Fonction de validation
  const validateForm = () => {
    let newErrors = {};

    if (!data.nom) newErrors.nom = "Le nom de l'organisation est requis.";
    if (!data.type) newErrors.type = "Veuillez sélectionner un type d'organisation.";
    if (!data.taille) newErrors.taille = "Veuillez sélectionner une taille.";
    if (!data.region) newErrors.region = "Veuillez choisir une région.";
    if (!data.district) newErrors.district = "Veuillez choisir un district.";
    if (!data.email) {
      newErrors.email = "L'email est requis.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = "Veuillez entrer une adresse email valide.";
    }
    
    if (!data.password) {
      newErrors.password = "Le mot de passe est requis.";
    } else if (data.password.length < 8) {
      newErrors.password = "Le mot de passe doit avoir au moins 8 caractères.";
    }

    if (data.password !== data.confirmPassword) {
      newErrors.confirmPassword = "Les mots de passe ne correspondent pas.";
    }

    if (!data.remember) {
      newErrors.remember = "Vous devez accepter les termes et conditions.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Gestion des changements de champs
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData({
      ...data,
      [name]: type === 'checkbox' ? checked : value,
    });

    if ( name === 'confirmPassword') {
      if (data.password !== value) {
        setErrors({
          ...errors,
          confirmPassword: "Les mots de passe ne correspondent pas.",
        });
        // setPasswordError("Les mots de passe ne correspondent pas.");
      }else{
        setErrors({
          ...errors,
          confirmPassword: "",
        });
      }
    }else {
      setErrors({
        ...errors,
        [name]: null,
      });
    }

    // Effacer l'erreur si l'utilisateur corrige l'entrée
    // setErrors({
    //   ...errors,
    //   [name]: null,
    // });
  };

  // Envoi du formulaire
  const save = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      const updatedData = {
        ...data, 
        codeGenerated: Math.ceil(Math.random() * 9001) + 999,
      };

      setData({ ...data, 
        codeGenerated: Math.ceil(Math.random() * 9001) + 999});
console.log(updatedData,data)
//A décommenter
      // await axios.post(API_END_POINT + '/sendCode', updatedData);
      setPage(page + 1);
    } catch (error) {
      console.error('Erreur lors de l\'inscription:', error);
      setErrors({ api: "Une erreur est survenue. Veuillez réessayer plus tard." });
    } finally {
      setLoading(false);
    }
  };

    // Gestion du focus
    const handleFocus = (e) => {
      const { name } = e.target;
      setTouchedFields({
        ...touchedFields,
        [name]: true,
      });
    };
  
    // Gestion du blur
    const handleBlur = (e) => {
      const { name, value } = e.target;
  
      if (touchedFields[name] && value.trim() === "") {
        setErrors({
          ...errors,
          [name]: "Ce champ est requis.",
        });
      }
    };
  
    
  return (
    <div className="w-full p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow my-6">
      <h2 className="text-2xl font-bold text-gray-900 text-center">Créer un compte</h2>
      {/* {errors.api && <p className="text-red-500 text-sm">{errors.api}</p>} */}

      <form className="mt-8 space-y-2">
        <Input 
        label="Nom de l'organisation" 
        name="nom" value={data.nom} 
        onFocus={handleFocus} 
        onBlur={handleBlur}
        onChange={handleChange} 
        required error={errors.nom} />

        <Select 
          label="Type de l'organisation" 
          name="type" 
          onFocus={handleFocus} 
          onBlur={handleBlur}
          placeholder='Veuillez sélectionner' 
          options={["Une entreprise", "Un cabinet de recrutement", "Une agence d'intérim", "Une ESN"]}
          onChange={handleChange} 
          error={errors.type}
        />

        <Select 
          label="Taille" 
          name="taille" 
          onFocus={handleFocus} 
          onBlur={handleBlur}
          placeholder='Veuillez sélectionner' 
          options={["1 - 50", "51 - 100", "101 - 250", "+250"]}
          onChange={handleChange} 
          error={errors.taille}
        />

        <div className="grid-2">
          <Select 
            label="Région"
            name="region"
            onFocus={handleFocus} 
            onBlur={handleBlur}
            options={region}
            value={data.region}
            onChange={handleChange}
            error={errors.region}
          />
          <Select 
            label="District"
            name="district"
            onFocus={handleFocus} 
            onBlur={handleBlur}
            options={data.region ? district[data.region] : []}
            value={data.district}
            onChange={handleChange}
            error={errors.district}
          />
        </div>

        <Input 
          label="Email" 
          type='email' 
          name="email" 
          onFocus={handleFocus} 
          onBlur={handleBlur}
          value={data.email} 
          onChange={handleChange} 
          required 
          error={errors.email}
        />

        <div className="grid-2">
          <Input 
            label="Mot de passe" 
            type='password' 
            name="password" 
            onFocus={handleFocus} 
            onBlur={handleBlur}
            value={data.password} 
            onChange={handleChange} 
            required 
            error={errors.password}
          />
          <Input 
            label="Confirmation mot de passe" 
            type='password' 
            name="confirmPassword" 
            onFocus={handleFocus} 
            onBlur={handleBlur}
            value={data.confirmPassword} 
            onChange={handleChange} 
            required 
            error={errors.confirmPassword}
          />
        </div>

        <p className='text-start font-medium text-gray-900 text-sm'>
          Veuillez utiliser un mot de passe avec un minimum de 8 caractères.
        </p>

        <div className="flex items-start py-2">
          <div className="flex items-center h-5">
            <input 
              id="remember" 
              name="remember" 
              type="checkbox" 
              checked={data.remember} 
              onChange={handleChange} 
              className="w-4 h-4 border-gray-300 rounded bg-gray-50" 
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="remember" className="font-medium text-gray-900">
              J'accepte les{' '}
              <Link to="/termes-et-conditions" className="text-primary-700 hover:underline font-semibold">
                Termes et Conditions
              </Link>
            </label>
          </div>
        </div>
        {errors.remember && <p className="text-red-500 text-sm">{errors.remember}</p>}

        <ButtonBlack 
          isLoading={loading} 
          onClick={save} 
                  radius='sm'
        className="w-full  text-white py-2 px-4 rounded-sm "
        >
          S'inscrire maintenant
        </ButtonBlack>

        <div className="text-sm font-medium text-gray-500">
          Déjà un compte ?{' '}
          <Link to="/login" className="text-primary-700 hover:underline">
            Se connecter
          </Link>
        </div>
      </form>
    </div>
  );
};
// const CreateTrainerAccount = ({ setPage, page, data, setData }) => {
//   // State for form inputs
//   const [formData, setFormData] = useState({
//     nom: '',
//     organisationType: '',
//     region: '',
//     district: '',
//     email: '',
//     password: '',
//     password_confirmation: '',
//     remember: false
//   });

//   // State for errors
//   const [errors, setErrors] = useState({});
  
//   // Handle change for input/select fields
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === 'checkbox' ? checked : value,
//     });
//   };

//   // Validate form fields
//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.nom) newErrors.nom = 'Nom de l\'organisation est requis';
//     if (!formData.organisationType) newErrors.organisationType = 'Type de l\'organisation est requis';
//     if (!formData.region) newErrors.region = 'Région est requis';
//     if (!formData.district) newErrors.district = 'District est requis';
//     if (!formData.email) newErrors.email = 'Email est requis';
//     if (!formData.password) newErrors.password = 'Mot de passe est requis';
//     if (formData.password.length < 8) newErrors.password = 'Le mot de passe doit contenir au moins 8 caractères';
//     if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Les mots de passe ne correspondent pas';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     if (validateForm()) {
//       try {
//         const updatedData = {
//           ...data, 
//           codeGenerated: Math.ceil(Math.random() * 9001) + 999,
//         }
  
//         setData(updatedData)
//         console.log('Account created:', updatedData);
//         const response = await axios.post(API_END_POINT+'/sendCode', updatedData);
//         // Handle success response
//         console.log('Account created:', response.data);
//         // Redirect or show success message
//       } catch (error) {
//         console.error('Error creating account:', error);
//         // Handle error (show error message, etc.)
//       }
//     }
//   };

//   return (
//     <div className="w-full p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow mt-mt-6">
//       <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Créer un compte</h2>
//       <form className="mt-8 space-y-2" onSubmit={handleSubmit}>
//         <Input
//           label="Nom de l'organisation"
//           name="nom"
//           value={formData.nom}
//           onChange={handleChange}
//           error={errors.nom}
//         />
//         <Select
//           label="Type de l'organisation"
//           name="organisationType"
//           value={formData.organisationType}
//           onChange={handleChange}
//           error={errors.organisationType}
//         />

// <div className="grid-2">
//         <div className="relative mb-2">
//           <label htmlFor="region" className="block text-sm font-medium text-gray-700 text-start">Région</label>
//           <select
//             id="region"
//             name="region"
//             value={data.region}
//             onChange={handleChange}
//             className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             required
//           >
//             <option value="">Choisissez une région</option>
//             {region.map((item, index) => (
//               <option key={index} value={item}>{item}</option>
//             ))}
//           </select>
//         </div>

//         <div className="relative mb-2">
//           <label htmlFor="district" className="block text-sm font-medium text-gray-700 text-start">District</label>
//           <select
//             id="district"
//             name="district"
//             value={data.district}
//             onChange={handleChange}
//             className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             required
//           >
//             <option value="">Choisissez un district</option>
//             {data.region && district[data.region].map((item, index) => (
//               <option key={index} value={item}>{item}</option>
//             ))}
//           </select>
//         </div>
//       </div>

//         <Input
//           label="Email"
//           type="email"
//           name="email"
//           value={formData.email}
//           onChange={handleChange}
//           error={errors.email}
//         />

//         <div className="grid grid-cols-2 gap-x-4">
//           <Input
//             label="Mot de passe"
//             type="password"
//             name="password"
//             value={formData.password}
//             onChange={handleChange}
//             error={errors.password}
//           />
//           <Input
//             label="Mot de passe de confirmation"
//             type="password"
//             name="password_confirmation"
//             value={formData.password_confirmation}
//             onChange={handleChange}
//             error={errors.password_confirmation}
//           />
//         </div>
//         <p className="text-start font-medium text-gray-900 text-sm">
//           Veuillez utiliser un mot de passe avec minimum 8 caractères
//         </p>

//         <div className="flex items-start py-2">
//           <div className="flex items-center h-5">
//             <input
//               id="remember"
//               name="remember"
//               type="checkbox"
//               checked={formData.remember}
//               onChange={handleChange}
//               className="w-4 h-4 border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:focus:ring-primary-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
//             />
//           </div>
//           <div className="ml-3 text-sm">
//             <label htmlFor="remember" className="font-medium text-gray-900">
//               J'accepte les <Link to="termes-et-conditions" className="text-primary-700 hover:underline dark:text-primary-500">termes et conditions</Link> d'utilisation
//             </label>
//           </div>
//         </div>

//         <button
//           type="submit"
//           className="w-full px-5 py-3 text-base font-medium text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 sm:w-auto dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
//         >
//           S'inscrire maintenant
//         </button>

//         <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
//           Déjà un compte? <Link to="login" className="text-primary-700 hover:underline dark:text-primary-500">Se connecter</Link>
//         </div>
//       </form>
//     </div>
//   );
// };

export default CreateTrainerAccount;
